import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Icon from 'components/Icon';

import ModalContainer, { ModalContent } from './Modal.styled';

const Modal = ({
  show,
  toggleModal,
  children,
  modalProps,
  contentProps,
  closeButtonProps,
  banner,
}) => {
  useEffect(() => {
    const keyDownHandler = (e) => {
      if (
        e?.key?.toLowerCase() === 'escape' &&
        document.activeElement.tagName !== 'input' &&
        document.activeElement.tagName !== 'textarea'
      )
        toggleModal();
    };

    const removeHandler = () =>
      window.removeEventListener('keydown', keyDownHandler);

    if (show) window.addEventListener('keydown', keyDownHandler);
    else removeHandler();

    return () => removeHandler();
  }, [show, toggleModal]);

  useEffect(() => {
    document.body.style.overflow = show ? 'hidden' : null;
  }, [show]);

  return (
    <ModalContainer
      className={`absolute-inset${show ? ' is-active' : ''}`}
      {...modalProps}>
      <Button
        type="button"
        className="modal-background absolute-inset"
        onClick={toggleModal}
      />
      <ModalContent className={show ? 'is-active' : ''} {...contentProps}>
        {banner && <img src={banner} alt="modal banner" />}
        <Button
          type="button"
          className="close-button"
          onClick={toggleModal}
          {...closeButtonProps}>
          <Icon name="close" height="25px" width="25px" />
        </Button>
        {children}
      </ModalContent>
    </ModalContainer>
  );
};

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  modalProps: PropTypes.object,
  contentProps: PropTypes.object,
  closeButtonProps: PropTypes.object,
  banner: PropTypes.string,
};

export default Modal;
